
import { Admitad } from '@gate31/feature/Admitad/Admitad';

export class AdmitadDesk extends Admitad {}
